module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap2"
    }
  }, [_vm._v("Book One"), _c('br'), _vm._v("Lost Causes")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('i', [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E ALL AGREE THAT")]), _vm._v(" the seceded states, so called, are out of their proper practical relation with the Union, and that the sole object of the government, civil and military, in regard to those states, is to again get them into that proper, practical relation. I believe that it is not only possible, but in fact easier, to do this without deciding or even considering whether these states have ever been out of the Union, than with it. Finding themselves safely at home, it would be utterly immaterial whether they had ever been abroad.")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Last public speech of")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ABRAHAM LINCOLN")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("from a White House balcony,")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("APRIL")]), _vm._v(" 11, 1865")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("Grind down the traitors. Grind the traitors in the dust.")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONGRESSMAN THADDEUS STEVENS")]), _vm._v(",")]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_vm._v("after Lincoln’s assassination, 1865")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5605578","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/8-chap2.vue
// module id = 81
// module chunks = 0